document.addEventListener("DOMContentLoaded", function () {
  const addToCartButtons = document.querySelectorAll(".custom-add-to__cart");
  if (addToCartButtons.length > 0) {
    addToCartButtons.forEach((button) => {
      button.addEventListener("click", function () {
        const closestForm = this.closest("form");
        const variantId = closestForm.querySelector( ".size-variant__selection").value;
        const quantity = closestForm.querySelector(".js-qty__num").value;
        const requestData = {
          id: variantId,
          quantity: parseInt(quantity),
        };
        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error("Failed to add item to cart");
            }
            return response.json();
          })
          .then((data) => {
            const cart = new theme.CartDrawer();
            cart.init();
            cart.open();
          })
          .catch((error) => {
            console.error("Error adding item to cart:", error);
          });
      });
    });
  }

  const qtyWrappers = document.querySelectorAll('.cstm-js-qty__wrapper');
  qtyWrappers.forEach(wrapper => {
    const qtyInput = wrapper.querySelector('.js-qty__num');
    const minusButton = wrapper.querySelector('.js-qty__adjust--minus');
    const plusButton = wrapper.querySelector('.js-qty__adjust--plus');

    function updateQuantity(change) {
      let currentQty = parseInt(qtyInput.value, 10);
      if (isNaN(currentQty) || currentQty < 1) currentQty = 1;
      let newQty = currentQty + change;
      if (newQty < 1) newQty = 1;
      qtyInput.value = newQty;
    }
    minusButton.addEventListener('click', function () {
      updateQuantity(-1);
    });
    plusButton.addEventListener('click', function () {
      updateQuantity(1);
    });
    qtyInput.addEventListener('input', function () {
      let currentQty = parseInt(qtyInput.value);
      if (isNaN(currentQty) || currentQty < 1) {
        qtyInput.value = 1;
      }
    });
  });

  const sizeVariantSelection = document.querySelectorAll('.size-variant__selection');
  if (sizeVariantSelection.length > 0) {
    sizeVariantSelection.forEach((select) => {
      let closeElement = select.closest('.grid__item');
      select.addEventListener('change', function () {
        const selectedOption = select.options[select.selectedIndex];
        const comparePrice = selectedOption.dataset.comparePrice || '';
        const mainPrice = selectedOption.dataset.mainPrice || '';
        const savingPrice = selectedOption.dataset.savingPrice || '';
        console.log(savingPrice)
        const priceElement = closeElement.querySelector('.grid-product__price');
        if (priceElement) {
          priceElement.innerHTML = comparePrice + mainPrice + savingPrice;
        }
      });
    });
  }

});
